export default "__VITE_ASSET__fda160e3__"